<!-- resources/js/Pages/EmailTemplates/Send.vue -->
<template>
  <div class="container-fluid">
    <!-- Remove Breadcrumb if you don't need it -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title">{{ title }}</h5>
      </div>

      <div class="card-body">
        <form @submit.prevent="submit">
          <div class="mb-3">
            <label class="form-label">Template</label>
            <select v-model="form.template_id" class="form-control" @change="loadTemplate">
              <option value="">Select a template</option>
              <option v-for="template in templates" :value="template.id">
                {{ template.name }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label">Subject</label>
            <input v-model="form.subject" type="text" class="form-control" required>
          </div>

          <div class="mb-3">
            <label class="form-label">Recipients (comma separated)</label>
            <input
              v-model="form.recipients_input"
              type="text"
              class="form-control"
              placeholder="email1@example.com, email2@example.com"
              required
            >
          </div>

          <div class="mb-3">
            <label class="form-label">Variables</label>
            <div v-for="(variable, index) in variables" :key="index" class="row mb-2">
              <div class="col-md-5">
                <input v-model="variable.key" type="text" class="form-control" placeholder="Variable name (without braces)">
              </div>
              <div class="col-md-5">
                <input v-model="variable.value" type="text" class="form-control" placeholder="Value">
              </div>
              <div class="col-md-2">
                <button type="button" class="btn btn-danger" @click="removeVariable(index)">
                  Remove
                </button>
              </div>
            </div>
            <button type="button" class="btn btn-secondary" @click="addVariable">
              Add Variable
            </button>
          </div>

          <div class="mb-3">
            <label class="form-label">Attachments</label>
            <input
              type="file"
              class="form-control"
              multiple
              @change="handleFileUpload"
            >
          </div>

          <div class="mb-3">
            <button type="submit" class="btn btn-primary" :disabled="sending">
              <span v-if="sending">Sending...</span>
              <span v-else>Send Email</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    templates: Array,
  },

  data() {
    return {
      form: {
        template_id: '',
        subject: '',
        recipients_input: '',
        attachments: [],
        variables: {}
      },
      variables: [],
      sending: false,
      previewHtml: ''
    }
  },

  methods: {
    addVariable() {
      this.variables.push({ key: '', value: '' });
    },

    removeVariable(index) {
      this.variables.splice(index, 1);
    },

    handleFileUpload(event) {
      this.form.attachments = event.target.files;
    },

    loadTemplate() {
      if (this.form.template_id) {
        const template = this.templates.find(t => t.id == this.form.template_id);
        if (template) {
          this.form.subject = template.name;
          this.previewHtml = template.html;
        }
      }
    },

    submit() {
      this.sending = true;

      // Convert variables to object format
      const variablesObj = {};
      this.variables.forEach(v => {
        if (v.key && v.value) {
          variablesObj[v.key] = v.value;
        }
      });

      // Convert recipients input to array
      const recipients = this.form.recipients_input.split(',')
        .map(email => email.trim())
        .filter(email => email);

      // Prepare form data for file upload
      const formData = new FormData();
      formData.append('template_id', this.form.template_id);
      formData.append('subject', this.form.subject);
      recipients.forEach(email => formData.append('recipients[]', email));

      // Add variables
      formData.append('variables', JSON.stringify(variablesObj));

      // Add attachments
      for (let i = 0; i < this.form.attachments.length; i++) {
        formData.append('attachments[]', this.form.attachments[i]);
      }

      this.$inertia.post(route('email-templates.send.post'), formData, {
        onSuccess: () => {
          this.sending = false;
        },
        onError: () => {
          this.sending = false;
        }
      });
    }
  }
}
</script>

<style scoped>
/* Add any custom styles you need */
</style>
